import Select from 'react-select'
import styled from '@emotion/styled'

type ThemedSelectProps = {
  options: { label: string; value: any }[]
  id: string
  isSearchable?: boolean
  defaultValue?: { label: string; value: any }
  maxWidthOptions: number
  color?: string
  hasShadow?: boolean
  isMulti?: boolean
  isDisabled?: boolean
  [x: string]: any
}

const StyledSelect = styled(Select)`
  & {
    /* background-color: #111827 !important; */
    cursor: pointer !important;

    div {
      overflow-x: hidden;
    }

    /* overflow-x: hidden; */

    input {
      /* color: white !important; */
    }

    > div:first-of-type {
      border-radius: 10px;
      border-color: ${({ hasShadow }) =>
        hasShadow ? 'transparent' : '#bdc6d9'};
      box-shadow: ${({ hasShadow }) =>
        hasShadow ? '0px 4px 5px rgba(0, 0, 0, 0.05)' : 'none'};
      min-height: 50px;
      cursor: pointer !important;
      > div:first-of-type {
        /* background-color: #111827; */
        border-top-left-radius: 12px;
        border-bottom-left-radius: 12px;
        cursor: pointer !important;
        div {
          font-size: 14px;
          color: ${props => props.selectedColor ?? '#989da9'};

          margin-left: ${props => (props.isSearchable ? '0px' : '10px')};
        }
      }
      > div:nth-of-type(2) {
        > span {
          display: none;
        }
      }
    }
  }
`

type ColourStyleArgs = {
  marginTopAtValueOf: string
  marginBottomAtValueOf: string
  maxWidthOptions: number
  selectedColor: string
}

const colourStyles = ({
  marginTopAtValueOf,
  marginBottomAtValueOf,
  maxWidthOptions,
  selectedColor,
}: ColourStyleArgs) => ({
  option: (styles: any, { data, isSelected, isFocused, isDisabled }: any) => {
    const getBackgroundColor = () => {
      if (isDisabled) return '#ecf0f1'
      if (isSelected || isFocused) return '#F7F8FB'
      return 'white'
    }

    return {
      ...styles,
      backgroundColor: getBackgroundColor(),
      opacity: isDisabled ? '0.75' : 1,
      cursor: isDisabled ? 'not-allowed' : 'auto',
      color: isSelected ? '#3300CC' : selectedColor,
      fontSize: '14px',
      borderRadius: '10px',
      maxWidth: maxWidthOptions,
      marginLeft: '6px',
      padding: '11px',
      marginTop: marginTopAtValueOf === data.value ? '4px' : '2px',
      marginBottom: marginBottomAtValueOf === data.value ? '4px' : '4px',
      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? '#F7F8FB' : '#e7e8e9'),
      },
    }
  },
})

const ThemedSelect: React.FC<ThemedSelectProps> = ({
  options,
  id,
  isSearchable,
  defaultValue,
  maxWidthOptions,
  color,
  hasShadow,
  isMulti,
  isDisabled,
  ...rest
}) => {
  const marginTopAtValueOf = options?.[0]?.value
  const marginBottomAtValueOf = options?.slice(-1)[0]?.value
  const defaultColor = color ?? 'black'
  const selectedColor = !isDisabled && defaultColor ? defaultColor : '#989DA9'

  return (
    <StyledSelect
      options={options}
      id={id}
      isSearchable={isSearchable}
      defaultValue={defaultValue}
      styles={colourStyles({
        marginTopAtValueOf,
        marginBottomAtValueOf,
        maxWidthOptions,
        selectedColor,
      })}
      selectedColor={selectedColor}
      hasShadow={hasShadow}
      isMulti={isMulti}
      isDisabled={isDisabled}
      {...rest}
    />
  )
}

export default ThemedSelect
